import type { Customer } from '@/types'

export interface SaleBlockContext {
  isRefundMode: boolean
  isPaidOnlinePickup: boolean
}

/**
 * True when the attached customer can't be tendered.
 *
 * A blocked customer still comes back from search and can be attached, so
 * staff can read the notes. The BE refuses their payments (`customer_blocked`);
 * this is the same rule, shown before anyone reaches the tender screen.
 *
 * Refunds are left to the BE, and a paid online pickup takes no payment.
 */
export function isSaleBlocked(
  customer: Pick<Customer, 'is_blocked'> | null | undefined,
  { isRefundMode, isPaidOnlinePickup }: SaleBlockContext,
): boolean {
  if (isRefundMode || isPaidOnlinePickup) return false
  return customer?.is_blocked === true
}
